export default __webpack_public_path__ + "static/media/VerifiedIcon.9e492b5f.svg";